import { render, staticRenderFns } from "./SimpleInfoBox.vue?vue&type=template&id=6f0e2132&scoped=true&"
import script from "./SimpleInfoBox.vue?vue&type=script&lang=js&"
export * from "./SimpleInfoBox.vue?vue&type=script&lang=js&"
import style0 from "./SimpleInfoBox.vue?vue&type=style&index=0&id=6f0e2132&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0e2132",
  null
  
)

export default component.exports